import Section from "../ui_elements/transparency_portal/Section";
import Glossary from "../ui_elements/transparency_portal/Glossary";
import FAQs from "../ui_elements/transparency_portal/FAQs";
import {
  FaDollarSign,
  FaClipboardList,
  FaFileInvoice,
  FaFileAlt,
  FaGavel,
  FaBriefcase,
  FaBook,
  FaChartLine,
  FaHandHoldingUsd,
  FaClipboardCheck,
  FaUserTie,
} from "react-icons/fa";

const TransparencyPortalPreviousManagement = () => {
  const topButtons = [
    { id: 1, name: "Acesso ao Portal da Transparência", anchor: "portal-transparencia" },
    { id: 2, name: "Despesas", anchor: "despesas" },
    { id: 3, name: "Receitas", anchor: "receitas" },
    { id: 4, name: "Responsabilidade Fiscal", anchor: "responsabilidade-fiscal" },
    { id: 5, name: "COVID-19", anchor: "covid-19" },
    { id: 6, name: "Licitações e Contratos", anchor: "licitacoes-contratos" },
    { id: 7, name: "Pessoal", anchor: "pessoal" },
    { id: 8, name: "Planejamento e Orçamento", anchor: "planejamento-orcamento" },
    { id: 9, name: "Convênios e transferências", anchor: "convenios-transferencias" },
    { id: 10, name: "Saúde", anchor: "saude" },
    { id: 11, name: "Educação", anchor: "educacao" },
    { id: 12, name: "Estrutura Organizacional", anchor: "estrutura-organizacional" },
    { id: 13, name: "Obras", anchor: "obras" },
    { id: 14, name: "Atos Normativos Próprios", anchor: "atos-normativos-proprios" },
  ];

  const sections = [
    {
      id: "portal-transparencia",
      title: "ACESSO AO PORTAL DA TRANSPARÊNCIA",
      items: [
        { 
          id: 1, 
          name: "Portal da Transparência - Gestão Atual", 
          url: "/transparencia",
          icon: FaFileAlt 
        },
      ],
    },
    {
      id: "despesas",
      title: "DESPESAS",
      description: "Gastos pelo Ente para a disponibilização dos serviços públicos e realização de investimentos que possam atender às necessidades da população.",
      items: [
        {
          id: 1,
          name: "Despesa",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/despesa?classificacao=orgao&dataini=01/01/2024&datafim=31/12/2024",
          icon: FaFileInvoice,
        },
        {
          id: 2,
          name: "Ordem cronológica",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/ordem-cronologica?data=01/2024",
          icon: FaFileInvoice,
        },
        {
          id: 3,
          name: "Emenda Parlamentar",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/emenda-parlamentar?dataini=01/01/2024&datafim=31/12/2024",
          icon: FaFileInvoice,
        },
        {
          id: 4,
          name: "Repasses à Câmara Municipal (Duodécimo)",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/duodecimos",
          icon: FaFileInvoice,
        },
        {
          id: 5,
          name: "Restos a Pagar",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/rppagos",
          icon: FaFileInvoice,
        }
      ]
    },
    {
      id: "receitas",
      title: "RECEITAS",
      description: "Dinheiro que o Ente arrecada, em sua maioria por meio de tributos, que será utilizado com o objetivo de custear as despesas e os investimentos realizados para atender às necessidades da população.",
      items: [
        {
          id: 1,
          name: "Receita",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/receita?classificacao=receita&exercicio=2024&mesini=1&mesfim=12",
          icon: FaDollarSign,
        },
        {
          id: 2,
          name: "Dívida Ativa",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/dividaativa",
          icon: FaDollarSign,
        },
        {
          id: 3,
          name: "Renúncia Fiscal",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/renuncias-fiscais",
          icon: FaDollarSign,
        }
      ]
    },
    {
      id: "responsabilidade-fiscal",
      title: "RESPONSABILIDADE FISCAL",
      description: "Cumprimento dos limites definidos pela Lei de Responsabilidade Fiscal (LRF) e análise de desempenho da execução orçamentária do Ente.",
      items: [
        {
          id: 1,
          name: "Relatório de Gestão Fiscal (RGF)",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/relatorio-de-gestao-fiscal-rgf",
          icon: FaClipboardCheck,
        },
        {
          id: 2,
          name: "Relatório Resumido de Execução Orçamentária (RREO)",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/relatorio-resumido-da-execucao-orcamentaria-rreo",
          icon: FaClipboardCheck,
        },
        {
          id: 3,
          name: "Balanço Geral",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/balanco-geral",
          icon: FaClipboardCheck,
        },
        {
          id: 4,
          name: "Contas de Gestão",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/contas-de-gestao",
          icon: FaClipboardCheck,
        },
        {
          id: 5,
          name: "Relatório de Gestão",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/relatorio-de-gestao",
          icon: FaClipboardCheck,
        },
        {
          id: 6,
          name: "Apreciação das Contas de Governo",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/apreciacao-das-contas-de-governo",
          icon: FaClipboardCheck,
        },
        {
          id: 7,
          name: "Julgamento das Contas do Chefe do Executivo",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/julgamento-das-contas-do-chefe-do-executivo",
          icon: FaClipboardCheck,
        },
        {
          id: 8,
          name: "Lei de Responsabilidade Fiscal (LRF)",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/lei-responsabilidade-fiscal",
          icon: FaClipboardCheck,
        }
      ]
    },
    {
      id: "covid-19",
      title: "COVID-19",
      items: [
        {
          id: 1,
          name: "Despesas Covid",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/coviddespesa",
          icon: FaFileAlt
        },
        {
          id: 2,
          name: "Licitações Covid",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/covidlicitacao",
          icon: FaFileAlt
        },
        {
          id: 3,
          name: "Contratos Covid",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/covidcontratos",
          icon: FaFileAlt
        },
        {
          id: 4,
          name: "Receitas Covid",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/covidreceita",
          icon: FaFileAlt
        }
      ]
    },
    {
      id: "licitacoes-contratos",
      title: "LICITAÇÕES E CONTRATOS",
      description: "Informações sobre os processos de compras de materiais e serviços realizados pelo Ente.",
      items: [
        {
          id: 1,
          name: "Empresas inidôneas e Suspensas",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/empresas-inidoneas",
          icon: FaUserTie
        },
        {
          id: 2,
          name: "Licitações",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/licitacao?modalidades=&certames=&situacoes=&dataini=01/01/2024&datafim=31/12/2024",
          icon: FaUserTie
        },
        {
          id: 3,
          name: "Contratos",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/contratos?contratos=&dataini=01/01/2024&datafim=31/12/2024",
          icon: FaUserTie
        },
        {
          id: 4,
          name: "Atas de Registro de Preço",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/ata-de-registro-de-preco?atas=&fornecedores=&dataini=01/01/2024&datafim=31/12/2024",
          icon: FaUserTie
        },
        {
          id: 5,
          name: "Empresas inidôneas e Suspensas - Arquivos",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/empresas-inidoneas",
          icon: FaUserTie
        }
      ]
    },
    {
      id: "pessoal",
      title: "PESSOAL",
      description: "Gastos com folha de pagamento de pessoal, estagiários, diárias, informações sobre tabelas remuneratórias, procedimentos disciplinares.",
      items: [
        {
          id: 1,
          name: "Servidores",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/servidores?data=01/2024",
          icon: FaUserTie
        },
        {
          id: 2,
          name: "Estagiários",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/estagiarios?data=01/2024",
          icon: FaUserTie
        },
        {
          id: 3,
          name: "Terceirizados",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/terceirizados",
          icon: FaUserTie
        },
        {
          id: 4,
          name: "Padrão Remuneratório",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/padrao-remuneratorio",
          icon: FaUserTie
        },
        {
          id: 5,
          name: "Diárias",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/diarias",
          icon: FaUserTie
        },
        {
          id: 6,
          name: "Diárias - Tabela de Valores",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/diarias-externas",
          icon: FaUserTie
        },
        {
          id: 7,
          name: "Concursos e processo seletivo",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/editais-de-concursos",
          icon: FaUserTie
        }
      ]
    },
    {
      id: "planejamento-orcamento",
      title: "PLANEJAMENTO E ORÇAMENTO",
      description: "Publicação do Plano Plurianual do Ente, peças do orçamento e instrumentos de planejamento.",
      items: [
        {
          id: 1,
          name: "Lei de Diretrizes Orçamentárias (LDO)",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/lei-de-diretrizes-orcamentarias-ldo",
          icon: FaChartLine
        },
        {
          id: 2,
          name: "Lei Orçamentária Anual (LOA)",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/lei-orcamentaria-anual-loa",
          icon: FaChartLine
        },
        {
          id: 3,
          name: "Plano de Contratações Anual (PCA)",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/plano-de-contratacao-anual",
          icon: FaChartLine
        },
        {
          id: 4,
          name: "Plano estratégico Institucional",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/plano-estrategico-institucional",
          icon: FaChartLine
        },
        {
          id: 5,
          name: "Plano Plurianual (PPA)",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/plano-plurianual",
          icon: FaChartLine
        },
      ]
    },
    {
      id: "convenios-transferencias",
      title: "CONVÊNIOS E TRANSPARÊNCIAS",
      description: "Demonstrações sobre convênios e transferências, demais acordos e repasses.",
      items: [
        {
          id: 1,
          name: "Tranferências Voluntárias Recebidas",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/transferencias-recebidas",
          icon: FaHandHoldingUsd
        },
        {
          id: 2,
          name: "Acordos S/Recursos Financeiros",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/acordos",
          icon: FaHandHoldingUsd
        },
        {
          id: 3,
          name: "Tranferências Realizadas",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/transferencias-realizadas",
          icon: FaHandHoldingUsd
        },
      ]
    },
    {
      id: "saude",
      title: "SAÚDE",
      description: "Informações sobre plano e serviços de saúde e medicamentos fornecidos pelo SUS.",
      items: [
        {
          id: 1,
          name: "Plano Municipal Saúde",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/plano-municipal-saude",
          icon: FaFileAlt
        },
        {
          id: 2,
          name: "Relatório Gestão Municipal Saúde",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/relatorio-gestao-municipal-saude",
          icon: FaFileAlt
        },
      ]
    },
    {
      id: "educacao",
      title: "EDUCAÇÃO",
      description: "Informações sobre plano de educação e creches públicas.",
      items: [
        {
          id: 1,
          name: "Plano Municipal Educação",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/plano-municipal-educacao",
          icon: FaBook
        },
      ]
    },
    {
      id: "estrutura-organizacional",
      title: "ESTRUTURA ORGANIZACIONAL",
      description: "Estrutura organizacional",
      items: [
        {
          id: 1,
          name: "Estrutura Organizacional",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/transparencia/estrutura-organizacional",
          icon: FaBriefcase
        },
      ]
    },
    {
      id: "obras",
      title: "OBRAS",
      description: "Informações sobre as obras públicas do Ente",
      items: [
        {
          id: 1,
          name: "Obras",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/obras",
          icon: FaClipboardList
        },
      ]
    },
    {
      id: "atos-normativos-proprios",
      title: "ATOS NORMATIVOS PRÓPRIOS",
      description: "Atos normativos expedidos",
      items: [
        {
          id: 1,
          name: "Decretos",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/decretos",
          icon: FaGavel
        },
        {
          id: 2,
          name: "Portarias",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/portarias",
          icon: FaGavel
        },
        {
          id: 3,
          name: "Resoluções",
          url: "https://pmserrinharn.transparencia.topsolutionsrn.com.br/arquivos/resolucoes",
          icon: FaGavel
        },
      ]
    }
  ]

  return (
    <div className="p-8 space-y-8">
      {/* Top Buttons Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {topButtons.map((btn) => (
          <a
            key={btn.id}
            href={`#${btn.anchor}`}
            className="flex items-center justify-center text-center bg-blue-100 text-blue-900 font-semibold py-3 px-6 rounded-lg hover:bg-blue-200 transition duration-200"
          >
            {btn.name}
          </a>
        ))}
      </div>

      {/* Dynamic Sections */}
      {sections.map((section) => (
        <div key={section.id} id={section.id}>
          <h2 className="text-2xl font-bold text-gray-800 mb-3 flex items-center">
            {section.title}
            <span className="flex-1 border-t border-gray-300 ml-4"></span>
          </h2>
          <p className="mb-3">{section.description}</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {section.items.map((item) => (
              <Section
                key={item.id}
                name={item.name}
                url={item.url}
                icon={item.icon}
              />
            ))}
          </div>
        </div>
      ))}

      {/* Glossary and FAQs Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Glossary */}
        <div className="p-4 bg-gray-50 rounded-lg shadow-lg">
          <Glossary />
        </div>

        {/* FAQs */}
        <div className="p-4 bg-gray-50 rounded-lg shadow-lg">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Perguntas Frequentes
          </h2>
          <FAQs />
        </div>
      </div>

      {/* Footer Informativo */}
      <div className="mt-12 p-6 bg-gray-100 rounded-lg">
        <p className="text-gray-700 text-lg leading-relaxed">
          Conforme a Lei Complementar Federal 131/2009, a Prefeitura de Serrinha
          disponibiliza seu Portal da Transparência visando assegurar ao cidadão
          informações sobre as execuções orçamentárias e financeiras do
          município, o acompanhamento das aplicações dos recursos públicos,
          permitindo maior fiscalização e participação.
        </p>
        <p className="mt-4 text-gray-700 text-lg">
          Para informações pessoalmente, dirija-se à unidade física do
          <strong> SIC-OUVIDORIA</strong>, localizado na Prefeitura Municipal de
          Serrinha, Rua Manoel Joaquim de Souza, 150, Centro, 59.258-000,
          Serrinha/RN no horário das <strong>08:00h às 13:00h</strong>.
        </p>
      </div>
    </div>
  );
};

export default TransparencyPortalPreviousManagement;
